import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const Jobs = () => {
  useDocTitle('Jobs at Artisan Hosting');
  return (
    <>
      <NavBar />
      <div className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-blue-900 mb-4">Jobs</h1>
          <p className="text-gray-700 mb-4">We're currently working with a small team of contractors. If you're interested in collaborating, send your resume to <a href="mailto:hiring@artisanhosting.net" className="text-blue-900 underline">hiring@artisanhosting.net</a>.</p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>DevOps Contractor (part-time)</li>
            <li>Frontend Developer (contract)</li>
            <li>Technical Writer</li>
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Jobs;
